export const PURCHASE_ORDER_STATUS = {
  PENDING: "pending",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
} as const;

export const PURCHASE_ORDER_STATUS_LABEL: Record<string, string> = {
  [PURCHASE_ORDER_STATUS.PENDING]: "Chờ xử lý",
  [PURCHASE_ORDER_STATUS.COMPLETED]: "Hoàn thành",
  [PURCHASE_ORDER_STATUS.CANCELLED]: "Đã hủy",
};

export const PURCHASE_ORDER_STATUS_COLOR: Record<string, string> = {
  [PURCHASE_ORDER_STATUS.PENDING]: "yellow",
  [PURCHASE_ORDER_STATUS.COMPLETED]: "green",
  [PURCHASE_ORDER_STATUS.CANCELLED]: "red",
};

export const PAGE_STYLE = `
  @font-face {
    font-family: 'Roboto';
    src: url('/fonts/Roboto-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'Roboto';
    src: url('/fonts/Roboto-Bold.woff') format('woff');
    font-weight: 700;
    font-style: normal;
  }
  @font-face {
    font-family: 'Roboto';
    src: url('/fonts/Roboto-Italic.woff') format('woff');
    font-weight: 400;
    font-style: italic;
  }
  @page {
    size: A4;
    margin: 15mm;
  }
  body {
    font-family: 'Roboto', sans-serif;
    font-size: 11pt;
    color: #000;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
`;
